import React from 'react';
import { IVisitorAgreementDetailsFormProps } from './types';
import { FormGroup, SubmitButton, ButtonContainer } from '../../../form';
import { InputText, HtmlEditor, Checkbox } from '../../../formikBindings';
import { Button } from 'react-bootstrap';

const VisitorAgreementDetailsForm: React.FC<IVisitorAgreementDetailsFormProps> =
  ({ createMode, onDelete }) => (
    <>
      <FormGroup name="name" label="Name" required>
        <InputText name="name" maxLength={255} />
      </FormGroup>
      <FormGroup name="useDigitalSignature">
        <Checkbox name="useDigitalSignature" label="Use Digital Signature" />
      </FormGroup>
      <FormGroup name="content" label="Content" required>
        <HtmlEditor name="content" />
      </FormGroup>
      <ButtonContainer>
        {!createMode && (
          <Button variant="danger" onClick={onDelete}>
            Delete
          </Button>
        )}
        <SubmitButton>Save</SubmitButton>
      </ButtonContainer>
    </>
  );

export default VisitorAgreementDetailsForm;
